/* eslint-disable no-unused-vars */
import { getServerTimestamp } from '../@sgorg/game-backend-client-mock';
import { FORTUNE_COOLDOWN_KEY } from './dataTracking/fortuneCookie/FortuneCookieDataManager';

/**
 * Class For checking feature status / flags
 */
export class OMT_FeatureFlags {
  /**
   * constructor
   */
  constructor() {
    this._feature_RequestHelp = false;
    this._feature_RequestMoveHelp = false;
    this._feature_giftingSupported = false;
    this._feature_FriendshipChest = false;//G.featureUnlock.friendshipChest && G.featureUnlock.friendshipChest.enabled !== undefined ? G.featureUnlock.friendshipChest.enabled : false;
    this._asset_friendshipChest = {
      complete: !this.getFriendshipChestStory(),
      highPrio: !this.getFriendshipChestStory(),
    };
    this._feature_newFTUX = G.featureUnlock.FTUE5_0 !== undefined ? G.featureUnlock.FTUE5_0 : true;
    this._feature_askForBotOptInAtLoad = G.featureUnlock.botOptInOnLoad !== undefined ? G.featureUnlock.botOptInOnLoad : false;
    this._feature_doubleCoinsAtEoL = false;
    this._feature_3hGift = true;
    this._feature_gameTriggeredMessages = {
      bot: G.featureUnlock.gameTriggeredMessages.botMessages || false,
      a2u: G.featureUnlock.gameTriggeredMessages.a2uNotifications || false,
    };
    this._asset_eventPostcard = false;
  }

  /**
   * Called at World.js to determine if requestHelp is active or not
   */
  checkFeatureRequestHelp() {
    if (OMT.systemInfo.deviceIsIOS) { this._feature_RequestHelp = false; return; }
    if (G.featureUnlock.requestHelp && G.featureUnlock.unlockLevels.requestHelp) { // Checking necessary jsons exists
      // Is RequestHelp on G.OMTSettings, and is level > set level
      this._feature_RequestHelp = G.featureUnlock.requestHelp && G.saveState.getLastPassedLevelNr() >= G.featureUnlock.unlockLevels.requestHelp;
    }
  }

  /**
   * Called at World.js to determine if requestMoveHelp is active or not.
   */
  checkFeatureRequestMoveHelp() {
    if (OMT.systemInfo.deviceIsIOS) { this._feature_RequestMoveHelp = false; return; }
    if (G.featureUnlock.requestMoveHelp && G.featureUnlock.unlockLevels.requestMoveHelp) { // Checking necessary jsons exists
      // is the feature unlocked, and if we're passed the minimum required level number.
      this._feature_RequestMoveHelp = G.featureUnlock.requestMoveHelp && G.saveState.getLastPassedLevelNr() >= G.featureUnlock.unlockLevels.requestMoveHelp;
    }
  }

  /**
   * Called at various places to see if RequestHelp is active
   * @returns {boolean}
   */
  getFeatureRequestHelp() {
    return this._feature_RequestHelp;
  }

  /**
   * is request move help enabled
   * @returns {boolean}
   */
  getFeatureRequestMoveHelp() {
    return this._feature_RequestMoveHelp;
  }

  /**
   * check if 3 hour gift is enabled
   * @returns {Boolean}
   */
  getFeature3hGift() {
    return this._feature_3hGift;
  }

  /**
   * check if game-triggered bot messages are enabled
   */
  getFeatureGameTriggeredBotMessages() {
    return this._feature_gameTriggeredMessages.bot;
  }

  /**
   * check if game-triggered A2U notifications are enabled
   */
  getFeatureGameTriggeredA2UNotifications() {
    return this._feature_gameTriggeredMessages.a2u;
  }

  /**
   * true if the 3 hour gift should appear in the shop
   * @returns {Boolean}
   */
  is3hGiftInShop() {
    return G.OMTsettings.elements.Window_shop2 && G.OMTsettings.elements.Window_shop2.isShowing3hGift && G.IAP && !OMT.systemInfo.deviceIsIOS;
  }

  /**
   * check if the 3 hour gift is active for the current level state
   * @returns {boolean}
   */
  getFeature3hGiftActiveByLevel() {
    let result = false;
    if (this.getFeature3hGift()) {
      const unlockLevel = G.featureUnlock.unlockLevels.isShowing3hGift || Infinity;
      result = G.saveState.getLastPassedLevelNr() >= unlockLevel;
    }
    return result;
  }

  /**
   * checks if gifting is supported
   * @returns {boolean}
   */
  isGiftingSupported() {
    return this._feature_giftingSupported;
  }

  /**
   * checks if rewarded ads are available
   * @returns {boolean}
   */
  rewardedAdsAvailable() {
    return false;//FBInstant.getSupportedAPIs().includes('getRewardedVideoAsync');// && !OMT.systemInfo.browserIsIE;
  }

  /**
   * checks if interstitial ads are available
   * @returns {boolean}
   */
  interstitialAdsAvailable() {
    return false;//FBInstant.getSupportedAPIs().includes('getInterstitialAdAsync');// && !OMT.systemInfo.browserIsIE;
  }

  /**
   * checks if friendship chest is available
   * @returns {boolean}
   */
  getFeatureFriendshipChest(checkiOS = true) {
    if (checkiOS && OMT.systemInfo.deviceIsIOS) return false;
    return this._feature_FriendshipChest;
  }

  /**
   * Returns whether or not the friendship chest has the storymode feature or not
   * @returns {boolean}
   */
  getFriendshipChestStory() {
    return G.featureUnlock.friendshipChest.storyMode || false;
  }

  /**
   * get the friendship chest asset status
   * @returns {Object} { complete, highPrio }
   */
  getFriendshipChestAssetStatus() {
    return {
      complete: this._asset_friendshipChest.complete,
      highPrio: this._asset_friendshipChest.highPrio,
    };
  }

  /**
   * set the friend chest asset status
   * @param {boolean} highPrioStat
   * @param {boolean} completeStat
   */
  setFriendshipChestAssetStatus(highPrioStat, completeStat = false) {
    this._asset_friendshipChest.complete = completeStat;
    this._asset_friendshipChest.highPrio = highPrioStat;
  }

  /**
   * check if we need to ask for bot-opt-in at game load
   * @returns {boolean}
   */
  getAskForBotOptInAtLoad() {
    return this._feature_askForBotOptInAtLoad;
  }

  /**
   * check if we are using the new FTUX
   * @returns {boolean}
   */
  getUseNewFTUX() {
    return this._feature_newFTUX;
  }

  /**
   * check if the friendship chest is unlocked for the current level state
   * @returns {boolean}
   */
  getFeatureFriendshipChestActiveByLevel(checkiOS = true) {
    let result = false;
    if (this.getFeatureFriendshipChest(checkiOS)) {
      const unlockLevel = G.featureUnlock.unlockLevels.friendshipChest || Infinity;
      result = G.saveState.getLastPassedLevelNr() >= unlockLevel;
    }
    return result;
  }

  /**
   * check if we should have the option to get double coins at the end of a level
   * @returns {boolean}
   */
  getDoubleCoinsAtEoL() {
    this._feature_doubleCoinsAtEoL = G.saveState.getLastPassedLevelNr() >= (G.featureUnlock.unlockLevels.coinDouble || 0);
    return this._feature_doubleCoinsAtEoL;
  }

  /**
   * check if fullscreen is supported, will only be true for OK.ru atm
   * @returns {boolean}
   */
  isFullScreenSupported() {
    return false;
  }

  /**
   * Check if we can show that extra continue button on Levels to give them a booster
   * in that level if they do
   */
  canLevelShowAdContinueBooster() {
    const boostersActive = G.saveState.mysteryGift_getCurrentGifts().length === 0;
    const over40 = G.saveState.getLastPassedLevelNr() >= (G.featureUnlock.unlockLevels.preLevelBoosterAd || 40);
    const hasBoosters = G.saveState.getBoosterAmount(7) === 0 && G.saveState.getBoosterAmount(8) === 0;
    return boostersActive && over40 && hasBoosters;
  }

  /**
   * check if FTUX is enabled for the user
   * @returns {boolean}
   */
  isFTUXEnabled() {
    if (!this.getUseNewFTUX() || !G.OMTsettings.FTUXSettings.levelCutOff) return true;
    return G.saveState.getLastPassedLevelNr() < G.OMTsettings.FTUXSettings.levelCutOff;
  }

  /**
   * Checks if Mystery gift is available based on levels completed.
   * equalLevel will check equal to or higher than level, instead of just higher
   * @param {boolean} equalLevel
   * @returns {boolean}
   */
  getMysteryGiftUnlockByLevel(equalLevel = false) {
    if (equalLevel) return G.saveState.data.levels.length >= G.featureUnlock.unlockLevels.mysteryGift;
    return G.saveState.data.levels.length > G.featureUnlock.unlockLevels.mysteryGift;
  }

  /**
   * Checks:
   * 1. Is the event enabled?
   * 2. Is there a time range to this event? If there is, is it within the event time?
   * @param {boolean} checkLevel
   * @returns {boolean}
   */
  async getEventPostcardFeature(checkLevel) {
    let event = G.featureUnlock.eventPostcard.enabled;
    if (G.featureUnlock.eventPostcard.range) {
      const { start } = G.featureUnlock.eventPostcard.range;
      const { end } = G.featureUnlock.eventPostcard.range;
      try {
        const today = await getServerTimestamp();
        event = today > start && today < end;
      } catch (err) {
        event = false;
      }
    }
    if (checkLevel && event) {
      event = G.saveState.getLastPassedLevelNr() >= G.featureUnlock.unlockLevels.eventPostcard;
    }
    return event;
  }

  /**
   * Gets the status of the assets relating to the postcards
   * @returns {boolean}
   */
  getEventPostcardAssetStatus() {
    return this._asset_eventPostcard;
  }

  /**
   * Sets the status of the assets relating to the postcards
   * @param {boolean} complete
   */
  setEventPostcardAssetStatus(complete) {
    this._asset_eventPostcard = complete;
  }

  /**
   * Check if the fortune cookie event is currently active
   * @param {boolean} checkActiveTime
   */
  async getFortuneCookieEvent(checkActiveTime = true) {
    let result = G.featureUnlock.fortuneCookie.enabled;
    if (result && checkActiveTime) {
      result = G.saveState.getUserCooldownRemaining(FORTUNE_COOLDOWN_KEY.COOLDOWN, '') === 0;
      if (result) {
        const today = new Date(await getServerTimestamp());
        result = G.featureUnlock.fortuneCookie.activeDays.indexOf(today.getUTCDay()) > -1;
      }
    }
    return result;
  }
}
